export const ServicesSlug = 'service';
export const ServiceFormSlug = 'termin';

export function getServicesUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${ServicesSlug}`;
}

export function getServiceFormUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${ServicesSlug}/${ServiceFormSlug}`;
}
